import { EntryContextProvider } from '../../../context/EntryContext'
import { CaseContextProvider } from '../../../context'
import EntriesDashboardContainer from '../../../containers/EntriesDashboardContainer'

export const EntriesDashboard = (): JSX.Element => {
  return (
    <EntryContextProvider>
      <CaseContextProvider>
        <EntriesDashboardContainer />
      </CaseContextProvider>
    </EntryContextProvider>
  )
}
